const IAM_SCOPES = [
  'openid',
  'profile',
  'read:permissions',
  // You can add more scopes (granted services) here
  'terra',
  'terra:read',
  'terra:write',
  'terra-payment',
  'terra-payment:payment-config',
  'merchant-bff',
];

const MODULE_NEED_CONFIG_MAPPER = ["vnpay_topup", "vnpay_billing"]

export default {
  IAM_SCOPES,
  ALL: 'all',
  TABLET_WIDTH: 768,
  MODULE_NEED_CONFIG_MAPPER,
};
